module.exports = __webpack_public_path__ + "fonts/DM_Sans-500-latin-ext3.cc0d7bc.woff2";